import { render, staticRenderFns } from "./cabinet.page.vue?vue&type=template&id=28c8a969&scoped=true"
import script from "./cabinet.page.vue?vue&type=script&lang=ts"
export * from "./cabinet.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c8a969",
  null
  
)

export default component.exports